import { render, staticRenderFns } from "./ModalTutorial.vue?vue&type=template&id=86b6c1da"
import script from "./ModalTutorial.vue?vue&type=script&lang=js"
export * from "./ModalTutorial.vue?vue&type=script&lang=js"
import style0 from "./ModalTutorial.vue?vue&type=style&index=0&id=86b6c1da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports